import React from "react";

import { SessionDashboard } from "./SessionDashboard";

export const Dashboard: React.FC = () => {
  return <SessionDashboard />;
};

export default Dashboard;
